import './i18n';
import './App.css';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import RouterComponent from './components/Router/Router';
import useApi from './hooks/use-api';
import { isAdmin, isRegularUser, isAuthPage } from './utils/utils';
import { AppRoutes } from './utils/props';

const routerBaseName = process.env.REACT_APP_ROUTER_BASENAME || '/';

function AppContent() {
  const navigate = useNavigate();

  const user = useApi({
    path: '/user',
    callback: (data) => {
      localStorage.setItem('user_id', JSON.stringify(data.id));
      localStorage.setItem('first_name', JSON.stringify(data.first_name));
      localStorage.setItem('last_name', JSON.stringify(data.last_name));
      localStorage.setItem('company_name', JSON.stringify(data.company_name));
      localStorage.setItem('phone', JSON.stringify(data.phone));
      localStorage.setItem('mail', JSON.stringify(data.mail));
      localStorage.setItem('date_of_birth', JSON.stringify(data.date_of_birth));
      localStorage.setItem('type', JSON.stringify(data.type));
    }
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token && !isAuthPage()) {
      navigate(AppRoutes.Login);
    }
  }, [navigate]);

  return (
    <>
      <RouterComponent />
    </>
  );
}

function App() {
  return (
    <div className="h-full">
      <BrowserRouter basename={routerBaseName}>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
